import product from '../../assets/Products/ProductHome.avif'

export default function ProductHome() {
    return (
        <section className="relative min-h-[600px] lg:min-h-[790px] overflow-hidden bg-[#f4f5f6] ">

            {/* MOBILE / TABLET BACKGROUND */}
            <img
                src={product}
                alt="Product"
                className="absolute inset-0 w-full h-full object-cover lg:hidden"
            />

            {/* DESKTOP IMAGE SIDE */}
            <div className="hidden lg:block absolute top-0 right-0 h-full w-[60%]">
                <img
                    src={product}
                    alt="Product"
                    className="w-full h-full object-cover"
                    style={{
                        clipPath: "polygon(30% 0%, 100% 0%, 100% 100%, 13% 100%)",
                        objectPosition: "right center"
                    }}
                />
            </div>

            {/* CONTENT */}
            <div className=" flex items-center min-h-[600px] lg:min-h-[790px] ">
                <div className="mx-auto max-w-7xl w-full px-6 ">
                    <div className="max-w-[569px] bg-white/60 lg:bg-transparent backdrop-blur-sm lg:backdrop-blur-none p-4 rounded-lg mt-60 sm:mt-0 sm:ml-16 lg:ml-0 ">

                        <h1 className="font-semibold text-2xl sm:text-4xl lg:text-5xl text-black tracking-[0.7px] py-4 lg:py-8 ">
                            Smart Digital Products For Enterprises
                        </h1>

                        <p className="font-medium text-base lg:text-xl text-gray-700 lg:text-gray-600 leading-relaxed font-secondary">
                            Purpose-built software platforms designed to support recruitment,
                            workforce operations, and organizational learning with clarity,
                            reliability, and long-term performance.
                        </p>

                    </div>

                </div>
            </div>

        </section>
    );
}


